import { useParams } from 'react-router-dom';
import { getTranslate } from '../../../../utils/getTranslate/getTranslate';
import styles from '../Footer.module.scss';

export const Policy = () => {
  const t = getTranslate;
  const { lang } = useParams();
  const upDate = new Date();
  const upYear = upDate.getFullYear();

  return (
    <div className={styles.policy}>
      <div className="container">
        <div className={styles.policy_body}>
          <div className={styles.policy_text}>
            ©{upYear} {t('Орталық балалар кітапханасы, Өскемен қ.', 'Центральная детская библиотека, г. Усть-Каменогорск', lang)}
          </div>
        </div>
      </div>
    </div>
  );
};
